import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

import type { ComputedRef } from 'vue'
	import { computed } from 'vue'
	import { useGeneral } from '@/hooks'

	
export default /*#__PURE__*/_defineComponent({
  props: {
		text: { type: String, default: '' },
		icon: { type: String, default: '' },
		badge: { type: String, default: '' },
		tooltip: { type: String, default: '' },
		block: { type: Boolean, default: false },
		disabled: { type: Boolean, default: false },
		minWidth: { type: [String, Number], default: undefined }
	},
  emits: ['click'],
  setup(__props, { emit: $emit }) {

const $props = __props

	const { $t } = useGeneral()

	
	

	const minWidth: ComputedRef<number | undefined> = computed(() => ($props.minWidth !== undefined ? Number($props.minWidth) : undefined))
	const buttonStyle = computed(() => ($props.text ? '' : 'minWidth: 48px; padding: 0px 8px;'))

	const badgeEnabled: ComputedRef<boolean | undefined> = computed(() => !!$props.badge)
	const badgeTitle: ComputedRef<string> = computed(() => $props.badge)

	const tooltipEnabled: ComputedRef<boolean | undefined> = computed(() => !!$props.tooltip)
	const tooltipTitle: ComputedRef<string> = computed(() => $props.tooltip)

	function onClick() {
		$emit('click')
	}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_badge = _resolveComponent("v-badge")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_component_v_btn, {
    variant: "contained-flat",
    color: "success",
    "min-width": _unref(minWidth),
    block: $props.block,
    disabled: $props.disabled,
    style: _normalizeStyle(_unref(buttonStyle)),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (onClick()))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_badge, {
        modelValue: _unref(badgeEnabled),
        floating: "",
        color: "secondary",
        content: _unref($t)(_unref(badgeTitle))
      }, {
        default: _withCtx(() => [
          ($props.icon)
            ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 0,
                icon: $props.icon
              }, null, 8, ["icon"]))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_unref($t)($props.text)), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "content"]),
      (_unref(tooltipEnabled))
        ? (_openBlock(), _createBlock(_component_v_tooltip, {
            key: 0,
            activator: "parent",
            location: "bottom"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref($t)(_unref(tooltipTitle))), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["min-width", "block", "disabled", "style"]))
}
}

})